const getAge = (birthDate) =>
  Math.floor((new Date() - new Date(birthDate).getTime()) / 3.15576e10);

export const INITIAL_BIO = `Hello, my name is Artyom and I am a ${getAge(
  "1999-11-11"
)} y.o. frontend developer from Saint Petersburg, Russia.\r\n\r\nI currently work at Dr.Web and hold a master's degree in Software Engineering and Computer Technology from ITMO University.\r\n\r\nPress 'Start' button bellow to get my socials\r\nOr you can look at my projects in 'Bin' folder :)\r\nGood luck and have fun!`;
